module.exports = __webpack_public_path__ + "media/zh-company.5a37ec0d.mp4";